import React, { useState } from 'react';
import { MainLayout } from 'components';
import { Container, Row } from 'react-bootstrap';
import InternalContainer from 'components/internal-container/internal-container';
import SearchBox from 'components/SearchBox';
import CampanhasFilter from 'components/CampanhasMkt-components/CampanhasMktFilter/campanhas-filter';
import CampanhasTable from 'components/CampanhasMkt-components/CampanhasMktTable/campanhas-table';
import CampaignCards from 'components/CampanhasMkt-components/CampaignCards/campaign-cards';
import CampaignOnboardingModal from 'components/CampanhasMkt-components/CampaignOnboardingModal';
import { useHistory } from 'react-router-dom';
import { UseCampanhaHook, UseCampaignLgpd } from 'hooks/campanha-hook';
import AceiteLgpdModal from 'components/CampanhasMkt-components/AceiteLgpdModal/aceiteLgpdModal';
import { UseCampanhaContext } from 'context/campanha-context';
import { CampaignAudience } from 'models/campaign-mkt';
import {
  getCampaignOnboardingUserEmail,
  setCampaignOnboardingClose,
  shouldShowCampaignOnboarding,
} from 'utils/campanha-utils';
import IconChevron from '../../../assets/img/campanhas-de-marketing/arrow-filter.svg';
import {
  ArrowsStyled,
  ButtonArrowStyled,
  FlexItem,
  ImageStyled,
  MvpHeader,
  NewCampaignButton,
  NovadashStyled,
  PageHeader,
  PageTitle,
} from './style';

function CampanhasMkt(): JSX.Element {
  const history = useHistory();
  const { filterOpened } = UseCampanhaContext();
  const { onFilterClicked } = UseCampanhaHook();
  const { handleAcceptLgpd, showLgpdModal } = UseCampaignLgpd();
  const [onboardingUserEmail] = useState(() =>
    getCampaignOnboardingUserEmail(),
  );
  const [showOnboardingModal, setShowOnboardingModal] = useState(() =>
    shouldShowCampaignOnboarding(onboardingUserEmail),
  );

  const handleDecline = () => {
    history.goBack();
  };

  const handleOnboardingClose = () => {
    setCampaignOnboardingClose(onboardingUserEmail);
    setShowOnboardingModal(false);
  };

  const handleCreateCampaign = (audience?: CampaignAudience): void => {
    history.push('/criar-campanha', audience ? { audience } : undefined);
  };

  return (
    <MainLayout>
      <CampaignOnboardingModal
        show={showOnboardingModal}
        onClose={handleOnboardingClose}
      />

      <AceiteLgpdModal
        show={!showOnboardingModal && showLgpdModal}
        handleAccept={handleAcceptLgpd}
        handleDecline={handleDecline}
      />

      <Container fluid as={NovadashStyled}>
        <Row>
          <FlexItem className="col-md-12">
            <PageHeader>
              <PageTitle>Campanhas de Marketing</PageTitle>
              <NewCampaignButton
                type="button"
                onClick={() => handleCreateCampaign()}
              >
                Nova campanha
              </NewCampaignButton>
            </PageHeader>

            <CampaignCards onCreateCampaign={handleCreateCampaign} />
          </FlexItem>
        </Row>

        <Row>
          {filterOpened ? (
            <FlexItem className="col-md-3 animate-left">
              <CampanhasFilter />
            </FlexItem>
          ) : (
            <ButtonArrowStyled
              onClick={() => onFilterClicked(!filterOpened)}
              className="open-filter"
            >
              Abrir filtros
              <ArrowsStyled>
                <ImageStyled src={IconChevron} />
                <ImageStyled src={IconChevron} />
              </ArrowsStyled>
            </ButtonArrowStyled>
          )}

          <FlexItem
            className={`${
              filterOpened ? 'col-md-9' : 'animate-width col-md-12'
            }`}
          >
            <InternalContainer
              direction="column"
              justify="flex-end"
              align="flex-end"
            >
              <MvpHeader justify="space-between">
                <SearchBox
                  placeHolder="Pesquisar Campanha"
                  width={288}
                  height={32}
                  variant="campaigns"
                />
              </MvpHeader>
              <CampanhasTable />
            </InternalContainer>
          </FlexItem>
        </Row>
      </Container>
    </MainLayout>
  );
}

export default CampanhasMkt;
